<template>
  <div class="content" >
    <div class="title-box">
      <el-button type="default" size="small" @click="back()">返回</el-button>
      <div>{{txt}}</div>
    </div> 
      <el-form :model="ruleForm" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <div class="back-color-fff form-box">
        <span class="form-title">基础信息</span>
        <div class="form-item-box">
          <el-row>
            <el-col :span="12">
              <!-- 公司名称 -->
              <el-form-item label="公司名称" prop="tenantGuid">
                <el-select :disabled ="disabled ||$route.query.guid" @change="companyChange" v-model="ruleForm.tenantGuid" placeholder="请选择" filterable  class="w300">
                  <span slot="label">
                    <span class="fontC-red">*</span>
                    <span>公司名称</span>
                  </span>
                  <el-option v-for="item in tenantList" :key="item.sendTenantGuid" :label="item.sendTenantName"
                    :value="item.sendTenantGuid" >
                  </el-option>
                  </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 姓名 -->
              <el-form-item  prop="医生姓名">
                <span slot="label">
                  <span class="fontC-red">*</span>
                  <span>医生姓名</span>
                </span>
                <!-- <el-input :disabled ="disabled"   @input="ruleForm.doctorName=ruleForm.doctorName.replace(/[^\a-\z\A-\Z\u4E00-\u9FA5]/g,'')"  v-model="ruleForm.doctorName" class="w300" placeholder="请填写"></el-input>  -->
                <el-input :disabled ="disabled" ref="doctorNameRef"  @input="ruleForm.doctorName=ruleForm.doctorName.replace(/[^\a-\z\A-\Z\u4E00-\u9FA5]/g,'')" @blur="nameBlur(ruleForm.doctorName,ruleForm,'doctorName')"  v-model="ruleForm.doctorName" class="w300" placeholder="请填写"></el-input> 
              </el-form-item> 
            </el-col>
            <el-col :span="12">
              <!-- 手机号码 -->
              <el-form-item  prop="mobileNo">
                <span slot="label">
                  <span class="fontC-red">*</span>
                  <span >手机号码</span>
                </span>
                <el-input :disabled ="disabled"  @input="ruleForm.mobileNo=ruleForm.mobileNo.replace(/[^\d\-\d]/g,'')"  v-model="ruleForm.mobileNo" class="w300" maxlength="13" placeholder="请填写"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 性别 -->
              <el-form-item prop="sex"  >
                <span slot="label">
                  <span class="fontC-red" >*</span>
                  <span>性别</span>
                </span>
                <el-select :disabled ="disabled" v-model="ruleForm.sex" placeholder="请选择" class="w300" >
                  <el-option v-for="item in sexList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select> 
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 关联医院 -->
              <el-form-item  prop="medName" >
                <span slot="label">
                  <span class="fontC-red">*</span>
                  <span >所在医院</span>
                </span>
                <el-input :disabled ="disabled" @focus="medDialog=true" v-model="ruleForm.medName" class="w300" placeholder="请选择"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 选择产品 -->
              <el-form-item prop="goodsName">
                <span slot="label">
                  <!-- <span class="fontC-red">*</span> -->
                  <span>相关产品</span>
                </span>
                <el-input :disabled ="disabled"  @focus="goodsDialog=true" v-model="ruleForm.goodsName" class="w300"  placeholder="请选择"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 科室 -->
              <el-form-item  prop="medDeptGuid"  >
                <span slot="label">
                  <span class="fontC-red">*</span>
                  <span>所在科室</span>
                </span>
                <el-cascader :disabled ="disabled" placeholder="请选择" class="w300" ref="cascaderAddr" @change="handleDept" v-model="ruleForm.medDeptGuid"
                  :options="departList" clearable :props="cascaderProps" filterable></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 职称 -->
              <el-form-item  prop="technicalTitles" >
                <span slot="label">
                  <span >职称</span>
                </span>
                <el-select :disabled ="disabled" class="w300" v-model="ruleForm.technicalTitles" placeholder="请选择医生职称" clearable>
                  <el-option v-for="item in technicalTitlesList" :key="item.label" :value="item.label"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 指派公司 -->
              <el-form-item  prop="createUserTenantGuid">
                <span slot="label">
                  <span class="fontC-red">*</span>
                  <span>指派公司</span>
                </span>
                <el-select :disabled ="disabled" @change="onChanCreateUserTenant" v-model="ruleForm.createUserTenantGuid" placeholder="请选择" class="w300" filterable>
                  <el-option v-for="item in serviceTenants" :key="item.guid" :label="item.tenantName" :value="item.guid"> </el-option>
                </el-select> 
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 业务指派人员 -->
              <el-form-item  prop="createUserId">
                <span slot="label">
                  <span class="fontC-red">*</span>
                  <span >业务指派人员</span>
                </span>
                <el-select @change="changeStaff" :disabled ="disabled" v-model="ruleForm.createUserId" placeholder="请选择" class="w300" filterable>
                  <el-option v-for="item in staffList" :key="item.userGuid" :label="item.staffName" :value="item.userGuid"> </el-option>
                </el-select> 
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 所属区域 -->
              <el-form-item  prop="addressList">
                <span slot="label">
                  <span class="fontC-red">*</span>
                  <span>所属区域</span>
                </span>
                <el-cascader :disabled ="disabled" placeholder="请选择" @change="handleAddress" ref="cascaderFirst" v-model="ruleForm.addressList" :options="options"
                  class="w300"></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 启用状态 -->
              <el-form-item  prop="addressList">
                <span slot="label">
                  <span>启用状态</span>
                </span>
                <el-radio-group class="w300" :disabled="disabled" v-model="ruleForm.bizState">
                  <el-radio label="Y">启用</el-radio>
                  <el-radio label="S">停用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 月门诊次数 -->
              <el-form-item  prop="monthDiagnoseNum">
                <span slot="label">
                  <span >月门诊次数</span>
                </span>
                <el-input :disabled ="disabled" placeholder="请填写"   type="number" v-model="ruleForm.monthDiagnoseNum" class="w300" ></el-input>
              </el-form-item> 
            </el-col>
            <el-col :span="12">
              <!-- 每次门诊量 -->
              <el-form-item  prop="diagnoseNum" >
                <span slot="label">
                  <span >每次门诊量</span>
                </span>
                <el-input :disabled ="disabled" placeholder="请填写"  type="number" v-model="ruleForm.diagnoseNum" class="w300"></el-input>
              </el-form-item> 
            </el-col>
            <el-col :span="12">
              <!-- 适应症发病率 -->
              <el-form-item prop="attackRate">
                <span slot="label">
                  <span >适应症发病率</span>
                </span>
                <el-input :disabled ="disabled" placeholder="请填写" type="number"  @input="this.value=this.value.toString().match(/^\d+(?:\.\d{0,2})?/)" v-model="ruleForm.attackRate" class="w300" ></el-input>
              </el-form-item> 
            </el-col>
            <el-col :span="12">
              <!-- 处方强度 -->
              <el-form-item  prop="recipeStrength">
                <span slot="label">
                  <span>处方强度</span>
                </span>
                <el-input :disabled ="disabled"  placeholder="请填写"  type="number" v-model="ruleForm.recipeStrength" class="w300" ></el-input>
              </el-form-item> 
            </el-col>
            <el-col :span="12">
              <!-- 潜力量 -->
              <el-form-item prop="potentialMeasure" >
                <span slot="label">
                  <span >潜力量</span>
                </span>
                <el-input :disabled ="disabled"  placeholder="请填写" type="number" v-model="ruleForm.potentialMeasure" class="w300"></el-input>
              </el-form-item> 
            </el-col>
            <el-col :span="12">
              <!-- 目标量 -->
              <el-form-item prop="targetMeasure">
                <span slot="label">
                  <span >目标量</span>
                </span>
                <el-input :disabled ="disabled"  placeholder="请填写"    type="number" v-model="ruleForm.targetMeasure" class="w300"></el-input>
              </el-form-item> 
            </el-col>
            <el-col :span="12">
              <!-- 客户级别 -->
              <el-form-item  prop="level">
                <span slot="label">
                  <span >客户级别</span>
                </span>
                <el-select :disabled ="disabled" v-model="ruleForm.level"  placeholder="请选择" class="w300" >
                  <el-option v-for="item in levelList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select> 
              </el-form-item> 
            </el-col>
            <el-col :span="12">
              <!-- 次月投入计划 -->
              <el-form-item prop="inputPlan">
                <span slot="label">
                  <span >次月投入计划</span>
                </span>
                <el-input :disabled ="disabled" placeholder="请填写"    type="number" v-model="ruleForm.inputPlan" class="w300"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 建档时间 -->
              <el-form-item  >
                <span slot="label">
                  <span class="fontC-red">*</span>
                  <span >建档时间</span>
                </span>
                <el-date-picker :disabled ="disabled" @input="$forceUpdate();getAccountMonth()"  value-format="yyyy-MM-dd" placeholder="请选择" v-model="ruleForm.inputDate" style="width:300px;" ></el-date-picker>
              </el-form-item> 
            </el-col>
            <el-col :span="12">
              <!-- 核算月 -->
              <el-form-item prop="accountMonth" >
                <span slot="label">
                  <span class="fontC-red">*</span>
                  <span >核算月份</span>
                </span>
                <el-date-picker disabled  placeholder="请选择"  style="width:300px;"  value-format="yyyy-MM"  v-model="ruleForm.accountMonth" type="month" ></el-date-picker>
              </el-form-item> 
            </el-col>
          </el-row>
        </div>
      </div>
      </el-form>
      <div class="operte-btns back-color-fff" v-if="!disabled">
        <el-button size="small" @click="back()">取消</el-button>
        <el-button size="small"  v-if="txt == '新增医生'" @click="submitForm(2)">提交</el-button>
        <el-button size="small"  v-if="txt != '新增医生'" @click="upDateForm">提交</el-button>  
        <el-button size="small" class="" type="info" v-if="txt == '新增医生'" @click="submitForm(1)">添加下一个</el-button>
      </div>
    
      

    <el-dialog title="选择医院" :visible.sync="medDialog" width="900px">
      <el-row :gutter="24" class="mb30">
        <el-col :span="10">
          <div class="search-area-div w80">医院名称：</div>
          <el-input :disabled ="disabled" v-model="medPage.medNameKeyword" class="ipt-sty" placeholder="请输入"></el-input>
        </el-col>
        <el-col :span="10" >
          <div class="search-area-div w80">所在区域：</div>
          <el-cascader :disabled ="disabled"
              class="ipt-sty" 
              ref="cascaderAddr"
              placeholder="请选择"
              collapse-tags
              :options="provinceAndCity"
              :props="{ multiple: true, checkStrictly: false }"
              filterable
              @change="handleMedProvinceAndCity"
          ></el-cascader>
        </el-col>
        <el-col :span="4">
          <el-button size="medium" type="info" @click="getMedList(true)">搜索</el-button>
        </el-col>
      </el-row>
      <el-table :data="medList" style="width: 100%" row-key="guid" border ref="dataTable" class="mt15">
        <el-table-column width="60" label="选择" header-align="center" align="center">
          <template slot-scope="scope">
            <el-checkbox-group v-model="currentMedSelect" class="reimbursement-check">
              <el-checkbox :label="scope.row.guid" @change="checkMedBoxChange(scope.row)">{{scope.$index+1}}</el-checkbox>
            </el-checkbox-group>
          </template>
        </el-table-column> 
        <el-table-column prop="medName" label="医院名称" header-align="center" align="left" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="price" label="所在区域" header-align="center" align="left" width="300">
          <template slot-scope="scope">{{ scope.row.province | province}}{{ scope.row.city | city}}{{ scope.row.district | district}}</template>
        </el-table-column>
        <el-table-column prop="address" label="详细地址" header-align="center" align="left" width="300">
          <template slot-scope="scope">
            {{ scope.row.address||'-' }}
          </template>
        </el-table-column>
      </el-table> 
      <!-- 医院分页 -->
      <el-pagination class="pt back-color-fff" background @size-change="handleMedSizeChange" @current-change="handleMedCurrentChange" :page-sizes="[10, 30, 50]" :current-page="medPage.pageIndex" :page-size="medPage.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="medPage.totalRows">
      </el-pagination>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="medDialog = false">取消</el-button>
        <el-button size="medium" type="info" @click="sureMed">确定</el-button>
      </div>
    </el-dialog>


    <!-- 选择产品 -->
    <el-dialog title="选择产品" :visible.sync="goodsDialog" width="900px">
      <el-row :gutter="24" class="mb30">
        <el-col :span="13">
          <div class="search-area-div w80">产品名称：</div>
          <el-input :disabled ="disabled" v-model="goodsPage.goodsName" class="ipt-sty" placeholder="请输入"></el-input>
        </el-col>
        <el-col :span="3">
          <el-button size="medium" type="info" @click="getGoodsList(true)">搜索</el-button>
        </el-col>
      </el-row>
      <el-table :data="goodsList" style="width: 100%" row-key="guid" border @selection-change="handleGoodsSelectionChange" ref="dataTable">
        <el-table-column type="selection" width="55" :reserve-selection="true" > </el-table-column>
        <el-table-column prop="goodsName" label="产品" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="product">
              <img class="product-img" :src="scope.row.pictContent | filterImgUrl" alt="" />
              <p class="product-text w247">{{ scope.row.goodsName }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="goodsSpec" label="规格" header-align="center" align="left" width="170"
          show-overflow-tooltip></el-table-column>
        <el-table-column prop="producer" label="生产企业" header-align="center" align="center" width="170" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="price" label="单价" header-align="center" align="right" width="120">
          <template slot-scope="scope">
            <!-- 固定价 -->
            <span v-if="scope.row.priceType == '1'&&scope.row.price !== 0 && scope.row.price ">{{scope.row.price | numDigit | numFmt }}</span>
            <!-- 区间价 -->
            <span v-if="scope.row.priceType == '2'">
              {{ scope.row.price | numDigit | numFmt }}~{{ scope.row.maxPrice | numDigit | numFmt}}
            </span>
            <span v-if="scope.row.priceType == '1'&&(scope.row.price == 0 || !scope.row.price )">未定价</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="pt pb back-color-fff" background @size-change="handleGoodsSizeChange"
        @current-change="handleGoodsCurrentChange" :current-page="goodsPage.pageIndex" :page-size="goodsPage.pageSize"
        layout="total, prev, pager, next, jumper" :total="goodsPage.totalRows">
      </el-pagination>
      <div slot="footer" class="dialog-footer">
        <p class="t-left fl">本次已选择{{ multipleSelection.length }}个产品</p>
        <el-button plain size="medium" @click="goodsDialog = false">取消</el-button>
        <el-button size="medium" type="info" @click="sureGoods">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
  import provinceAndCity from '../../assets/js/china_address_v4s.js';
  import areaJson from '../../assets/js/china_address_v4.js';
  import dialogMap from '../../components/dialogMap';
  import recentDate from "@/uilt/recentDate";
  export default { 
    components:{
      dialogMap
    },
    data() {
      return {
        disabled:(this.$route.query.disabled == 'false'||!this.$route.query.disabled) ? false : true,
        tenantList:[],
        currentMedSelect: [],
        medList: [],
        medDialog:false,
        txt:'',
        dialogVisible:false,
        options: areaJson,
        provinceAndCity:provinceAndCity,
        fullscreenLoading:false,
        personList:[],
        ruleForm: {
          createUserId:'',
          tenantGuid:'',
          createUserTenantGuid: '',
          doctorName:'',
          mobileNo:'',
          sex:'',
          medName: '', //医院
          medGuid:'',

          medDeptGuid:'',//科室
          medDeptName:'',
          goodsInfoList:[],
          goodsName:'',
          
          province: '',
          city: '',
          district: '',

          addressList: [],
          venue: '',
          technicalTitles: "",//职称
          monthDiagnoseNum: "", //月门诊次数
          diagnoseNum: "", //每次门诊量
          attackRate: "", //适应证发病率
          recipeStrength: "", //处方强度
          potentialMeasure: "", //潜力量
          targetMeasure: "", //目标量
          level: "",
          inputPlan: "", //次月投入计划


          inputDate: "",
          bizState:'Y',//启用状态
        },
        departList: [],
        technicalTitlesList: [
          { label: "院长", value: "院长" },
          { label: "主治医师", value: "主治医师" },
          { label: "副院长", value: "副院长" },
          { label: "副主任医师", value: "副主任医师" },
          { label: "主任医师", value: "主任医师" },
          { label: "专家", value: "专家" },
          { label: "药剂科主任", value: "药剂科主任" },
          { label: "药剂科副主任", value: "药剂科副主任" },
        ],
        levelList: [
          { label: "A1", value: "A1" },
          { label: "A2", value: "A2" },
          { label: "A3", value: "A3" },
          { label: "B", value: "B" },
          { label: "C", value: "C" },
        ],
        sexList: [ 
          {
            value: '男',
            label: '男'
          },
          {
            value: '女',
            label: '女'
          }
        ],
        addressList: [],
        //医院
        medPage: {
          pageIndex: 1,
          tenantGuid:'',
          pageSize: 10,
          medNameKeyword: '',
          approvalStates: ["Y", "U"],
          totalPage: 0,
          totalRows: 0,
          cityNames:null
        },
  
        medObj:null,
        cascaderProps: { //角色级联
          value: 'guid',
          label: 'deptName',
          children: 'childList',
          multiple: false,
          emitPath:false
        },
        //产品
        goodsDialog:false,
        goodsPage:{
          pageIndex: 1,
          tenantGuid:'',
          pageSize: 10,
          goodsName: '',
          totalPage: 0,
          totalRows: 0,
        },
        goodsList:[],
        multipleSelection:[],
        serviceTenants: [],
        staffList:[]
      };
    },
    watch: {
    },
    created() {
      this.getTenantOperationRelList();
      this.getTechnicalTitlesList();
    },
    methods: { 
      onChanCreateUserTenant(val) { 
        this.ruleForm.createUserTenantGuid = val;
        this.ruleForm.createUserId = '';
        this.getStaffList(val);
      },
      getServiceTenants(tenantGuid) {
        if (!tenantGuid) {
          tenantGuid = this.ruleForm.createUserTenantGuid;
        }
        const params = {
          tenantGuid: tenantGuid,
          isService: false,
        }
        console.log(1111,params)
        this.api
          .postJson(
            `/${serverConfig.msCustomerService}/tenant/data/get-service-tenants`,
            params,
          )
          .then((res) => {
            if (res.data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
              this.$message.error(res.data.msg);
              return;
            }
            this.serviceTenants = res.data.data;
            // this.getStaffList(this.ruleForm.createUserTenantGuid);
          });
      },
      handleMedProvinceAndCity(){
        this.$nextTick(() => {
          let arr = this.$refs['cascaderAddr'].getCheckedNodes()
          this.medPage.cityNames = [];
          this.medPage.provinceNames = [];
          arr.forEach(item => {
            if (item.level == 1 && item.label == '北京市' || item.level == 1 && item.label == '上海市' || item.level == 1 && item.label == '重庆市' || item.level == 1 && item.label == '天津市') {
              this.medPage.provinceNames.push(item.label)
            } else if (item.level == 2 && item.label != '市辖区' && item.label != '县') {
              this.medPage.cityNames.push(item.label)
            }
          })
        })
      },
      getTechnicalTitlesList(guid) {
        let that = this;
        that.api.get(
          `/${serverConfig.msConfigureService}/sysparameter/data/get-detail-grp?tenantGuid=${guid}&code=YSZC_HYS`
        ).then((resp) => {
          console.log(resp.data);
          if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = resp.data.data;
            let arr = [];
            data.forEach((item) => {
              arr.push({
                label: item.name,
                value: item.parameterValue,
              });
            });
            that.technicalTitlesList = arr;
          }
        });
      },
      companyChange(val){
        this.ruleForm.technicalTitles = '';
        this.initPage();
        this.getServiceTenants(val);
      },
      getTenantOperationRelList(){ 
        let self = this; 
        self.api.get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list?isService=true`+'&tenantGuid='+localStorage.guid).then(res => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.tagsLoading = false;
            self.tenantList = res.data.data;  
            if (!this.ruleForm.tenantGuid) {
              this.ruleForm.tenantGuid = self.tenantList[0].sendTenantGuid;
            }
            this.getServiceTenants(this.ruleForm.tenantGuid);
            this.initPage();
          } else {
            self.$message.error(res.data.msg);
          }
        });
      },
      initPage() {
        if (this.$route.query.guid) {
          this.txt = this.$route.query.disabled?'医生详情':'编辑医生';
          this.getCustomerDetail();
        } else if (this.$route.query.medGuid) {
          this.ruleForm.inputDate = recentDate.getNowDay()
          this.linkReset();
        } else {
          this.reset();
          this.ruleForm.inputDate = recentDate.getNowDay()
          this.getMedList(true);
          this.getGoodsList(true);
          this.getDepartList();
          this.getAccountMonth();
        }
        // this.getStaffList(this.ruleForm.tenantGuid);
        this.getTechnicalTitlesList(this.ruleForm.tenantGuid)
      },
      getAccountMonth() {
        if (!this.ruleForm.inputDate) return;
        let tenantGuid = this.ruleForm.tenantGuid;
        this.api.get(
          `/${serverConfig.msConfigureService}/sysparameter/data/get-account-month?date=` +
          this.ruleForm.inputDate + "&tenantGuid=" +
          tenantGuid
        ).then(resp => {
          if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if(!resp.data.data){
              this.$message.error('请配置该药企的核算月！'); 
            }
            this.ruleForm.accountMonth = resp.data.data.substr(0, 4) + "-" + resp.data.data.substr(4, 2);
            this.$forceUpdate();
          }
        });
      },
      getDepartList() {
        this.api.get(
          `/${serverConfig.msPersonnelService}/med-dept/get-tree?tenantGuid=`+ this.ruleForm.tenantGuid
        ).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.departList = res.data.data;
          } else {
            this.$message.error(res.data.data.msg);
          }
        });
      },
      checkMedBoxChange(val) {
        console.log(val);
        if (this.currentMedSelect.indexOf(val.guid) > -1) {
          this.currentMedSelect = [];
          this.currentMedSelect.push(val.guid);
          this.medObj = val;
        }
      },
      sureMed() {
        if (!this.medObj) {
          this.$message.error('请选择医院！');
          return;
        }
        console.log(this.medObj)
        this.medDialog = false;
        this.ruleForm.medName = this.medObj.medName;
        this.ruleForm.medGuid = this.medObj.guid;
        this.ruleForm.addressList = [];
        this.$refs['cascaderFirst'].panel.clearCheckedNodes()
        console.log( this.$refs['cascaderFirst'].panel.clearCheckedNodes)
        if (this.medObj.province) {
          this.ruleForm.addressList.push(this.medObj.province)
          this.ruleForm.province = this.medObj.province
        }
        if (this.medObj.city) {
          this.ruleForm.addressList.push(this.medObj.city)
          this.ruleForm.city = this.medObj.city
        }
        if (this.medObj.district) {
          this.ruleForm.addressList.push(this.medObj.district)
          this.ruleForm.district = this.medObj.district
        }
        this.$forceUpdate();
      },
      handleDept(){
        this.ruleForm.medDeptName =  this.$refs['cascaderAddr'].getCheckedNodes()[0].label;
        console.log(this.ruleForm);
      },

      getMedList(val) {
        if (val) {
          this.medPage = {
            pageIndex: 1,
            tenantGuid: this.ruleForm.tenantGuid,
            pageSize: 10,
            approvalStates: ["Y", "U"],
            totalPage: 0,
            totalRows: 0,
            medNameKeyword: this.medPage.medNameKeyword,
            cityNames:this.medPage.cityNames,
          }
        }
        this.medPage.tenantGuid = this.ruleForm.tenantGuid;
        this.api.postCan(
          `/${serverConfig.msCustomerService}/med/data/get`,
          this.medPage
        ).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.medList = res.data.data.records;
            this.medPage.totalPage = res.data.data.totalPages;
            this.medPage.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.data.msg);
          }
        });
      },
      handleMedSizeChange(val) {
        this.medPage.pageSize = val;
        this.getMedList();
      },
      handleMedCurrentChange(val) {
        this.medPage.pageIndex = val;
        this.getMedList();
      },
      getGoodsList(val){
        if (val) {
          this.goodsPage = {
            pageIndex: 1,
            tenantGuid: this.ruleForm.tenantGuid,
            pageSize: 10,
            totalPage: 0,
            totalRows: 0,
            goodsName: this.goodsPage.goodsName,
          }
        }
        this.goodsPage.tenantGuid = this.ruleForm.tenantGuid;
        this.api.postCan(
          `/${serverConfig.msProductService}/goods/data/get`,
          this.goodsPage
        ).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.goodsList = res.data.data.records;
            this.goodsPage.totalPage = res.data.data.totalPages;
            this.goodsPage.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.data.msg);
          }
        });
      },
      changeStaff(val) {
        this.ruleForm.createUserId = val;
        this.$forceUpdate();
      },
      getStaffList(tenantGuid) {
        this.api.get(
          `/${serverConfig.msPersonnelService}/staff/get-staff-by-tenantGuid?tenantGuid=`+tenantGuid
        ).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.staffList = res.data.data;
          } else {
            this.$message.error(res.data.data.msg);
          }
        });
      },
      handleGoodsSizeChange(val) {
        this.goodsPage.pageIndex = val;
        this.getGoodsList();
      },
      handleGoodsCurrentChange(val) {
        this.goodsPage.pageIndex = val;
        this.getGoodsList();
      },
      handleGoodsSelectionChange(val){
        this.multipleSelection = val;
      },
      sureGoods(){
        if (!this.multipleSelection.length) {
          this.$message.error('请选择产品！');
          return;
        }
        let goodsInfoList = [];
        this.multipleSelection.forEach(item=>{
          goodsInfoList.push({
            goodsGuid:item.guid,
            goodsName:item.goodsName,
            goodsSpec:item.goodsSpec,
            goodsUnit:item.unitStyle,
          })
        })
        this.ruleForm.goodsInfoList = goodsInfoList;
        this.ruleForm.goodsName = this.getGoodsName(goodsInfoList);
        this.goodsDialog = false;
      },
      getGoodsName(res) {
        var list = [];
        if(!res) return '';
        if (res.length >= 2) {
          res.forEach((item, index) => {
            if (index <= 1) {
              list.push(item.goodsName);
            }
          });
          return list.join("、") + "等" + res.length + "个产品";
        } else {
          return res[0].goodsName;
        }
      },
      handleAddress(){
        const checkedNodes = this.$refs['cascaderFirst'].getCheckedNodes()
        let arr = checkedNodes[0].pathNodes
        console.log(arr)
        let codeArr = []
        arr.forEach(item => {
          codeArr.push(item.data.value)
        }) 
        this.ruleForm.province = codeArr[0];
        this.ruleForm.city = codeArr[1];
        this.ruleForm.district = codeArr[2];
        let venue = '';
        if (codeArr) {
          if (codeArr[0]) {
            venue = this.province(codeArr[0]);
          }
          if (codeArr[1]) {
            venue = this.province(codeArr[0]) + '/' + this.city(codeArr[1]);
          }
          if (codeArr[2]) {
            venue = this.province(codeArr[0]) + '/' + this.city(codeArr[1]) + '/' + this.district(codeArr[2]);
          }
        }
        this.ruleForm.venue = venue;
        
      },
      province(val) {
        let pr = '';
        this.options.forEach(function (j) {
          if (j.value == val) {
            pr = j.label;
          }
        });
        return pr;
      },
      city(val) {
        let ci = '';
        this.options.forEach(function (i) {
          if (i.children != null && i.children != '') {
            i.children.forEach(function (j) {
              if (j.value == val) {
                ci = j.label;
              }
            });
          }
        });
        return ci;
      },
      district(val) {
        let di = '';
        this.options.forEach(function (i) {
          if (i.children != null && i.children != '') {
            i.children.forEach(function (j) {
              if (j.children != null && j.children != '') {
                j.children.forEach(function (n) {
                  if (n.value == val) {
                    di = n.label;
                  }
                });
              }
            });
          }
        });
        return di;
      },
      getCustomerDetail() {
        let self = this;
        self.api.get(`/${serverConfig.msPersonnelService}/doctor/detail/`+ this.$route.query.guid).then((
        res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            console.log(res.data.data);
            let detail = res.data.data;
            this.ruleForm = {
              createUserId: detail.createUserId,
              tenantGuid:detail.tenantGuid,
              createUserTenantGuid: detail.createUserTenantGuid || detail.tenantGuid,
              doctorName:detail.doctorName,
              mobileNo:detail.mobileNo,
              sex:detail.sex,
              medName: detail.medName,//医院
              medGuid: detail.medGuid,
              medDeptGuid:detail.medDeptGuid,//科室
              medDeptName:detail.medDeptName,
              goodsInfoList:detail.goodsInfoList,
              goodsName:this.getGoodsName(detail.goodsInfoList),

              province: detail.province,
              city: detail.city,
              district: detail.district,
              venue: detail.venue,
              address: detail.address,
              addressList: [],
              bizState:detail.bizState,
              technicalTitles: detail.technicalTitles,//职称
              monthDiagnoseNum:  detail.monthDiagnoseNum,//月门诊次数
              diagnoseNum:  detail.diagnoseNum, //每次门诊量
              attackRate: detail.attackRate,//适应证发病率
              recipeStrength:detail.recipeStrength,//处方强度
              potentialMeasure:detail.potentialMeasure, //潜力量
              targetMeasure: detail.targetMeasure,//目标量
              level:detail.level,
              
              inputPlan:detail.inputPlan,//次月投入计划
              inputDate: detail.inputDate ? this.$moment(detail.inputDate).format('YYYY-MM-DD') : null,
              accountMonth: detail.accountMonth ? detail.accountMonth.substr(0, 4) + "-" + detail.accountMonth.substr(4, 2) : null
            }; 
            if (detail.province) {
              this.ruleForm.addressList.push(detail.province)
            }
            if (detail.city) {
              this.ruleForm.addressList.push(detail.city)
            }
            if (detail.district) {
              this.ruleForm.addressList.push(detail.district)
            }
            this.getMedList(true);
            this.getGoodsList(true);
            this.getDepartList();
            this.getAccountMonth();
            this.$forceUpdate();
            this.getTechnicalTitlesList(this.ruleForm.tenantGuid)
            this.getStaffList(this.ruleForm.createUserTenantGuid);
            this.getServiceTenants(this.ruleForm.tenantGuid);
     
          } else {
            self.$message.error(res.data.msg);
          }
        });
      },
      linkReset() {
        this.reset();
        this.ruleForm.medName = this.$route.query.medName;
        this.ruleForm.medGuid = this.$route.query.medGuid;
        this.ruleForm.tenantGuid = this.$route.query.tenantGuid;
        // this.ruleForm.createUserTenantGuid = this.ruleForm.tenantGuid;
        this.ruleForm.addressList = [];
        if (this.$route.query.province) {
          this.ruleForm.province = this.$route.query.province;
          this.ruleForm.addressList.push(this.$route.query.province)
        }
        if (this.$route.query.city) {
          this.ruleForm.city = this.$route.query.city;
          this.ruleForm.addressList.push(this.$route.query.city)
        }
        if (this.$route.query.district) {
          this.ruleForm.district = this.$route.query.district;
          this.ruleForm.addressList.push(this.$route.query.district)
        }
        this.getMedList(true);
        this.getGoodsList(true);
        this.getDepartList();
        this.getAccountMonth();
        this.$forceUpdate();
        this.getTechnicalTitlesList(this.ruleForm.tenantGuid)
        // this.getStaffList(this.ruleForm.tenantGuid);
        this.$forceUpdate();
      },
      reset(){
        this.txt = '新增医生';
        this.ruleForm = {
          medName:'',
          medGuid:'',
          inputDate:this.ruleForm.inputDate,
          accountMonth:this.ruleForm.accountMonth,
          province:'',
          city:'',
          district:'',
          addressList: [],
          venue: '',
          tenantGuid: this.ruleForm.tenantGuid,
          // createUserTenantGuid: this.ruleForm.tenantGuid,
          createUserTenantGuid: '',
          doctorName:'',
          mobileNo:'',
          sex:'',
          medDeptGuid:'',//科室
          medDeptName:'',
          goodsInfoList:[],
          goodsName:'',
          technicalTitles: "",//职称
          monthDiagnoseNum: "", //月门诊次数
          diagnoseNum: "", //每次门诊量
          attackRate: "", //适应证发病率
          recipeStrength: "", //处方强度
          potentialMeasure: "", //潜力量
          targetMeasure: "", //目标量
          level: "",
          inputPlan: "", //次月投入计划
          bizState:'Y',//启用状态
        };
        if(this.$refs.dataTable){
          this.$refs.dataTable.clearSelection();
        }
      },

      submitForm(type) {
        let self = this;
        
        if (!this.ruleForm.tenantGuid) {
           this.$message.error(`所属公司不能为空`)
          return;
        }
        if (!this.ruleForm.doctorName) {
           this.$message.error(`医生姓名不能为空`)
          return;
        }
        if (!this.ruleForm.mobileNo) {
           this.$message.error(`手机号不能为空`)
          return;
        }
        // const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
        // if (this.ruleForm.mobileNo && !reg.test(this.ruleForm.mobileNo)) {
        //    this.$message.error("请填写正确手机号")
        //   return;
        // }
        if (!this.ruleForm.sex) {
           this.$message.error(`性别不能为空`)
          return;
        }
        if (!this.ruleForm.medGuid) {
           this.$message.error(`所在医院不能为空`)
          return;
        }
        if (!this.ruleForm.medDeptGuid) {
           this.$message.error(`所在科室不能为空`)
          return;
        }
        if (!this.ruleForm.createUserTenantGuid) {
          this.$message.error('请选择指派公司')
          return
        }
        if (!this.ruleForm.createUserId) {
           this.$message.error(`请选择业务指派人`)
          return;
        }
        if (!this.ruleForm.province) {
           this.$message.error(`所属区域不能为空`)
          return;
        }
        if (this.$NameCheck(this,this.ruleForm.doctorName,'doctorName')) { // todo 姓名长度校验
          return
        }
  
        let ruleForm = this.ruleForm;
        let createUserName = '';
        let staffGuid = ''; 
        if(self.staffList){
          self.staffList.forEach((i)=>{
            if(i.userGuid == ruleForm.createUserId){
              createUserName = i.staffName;
              staffGuid = i.guid;
            }
          })
        }
        let promise = {
          serviceTenantGuid:localStorage.guid,
          createUserId: ruleForm.createUserId,
          createUserMobile: this.createUserMobile,
          createUserName: createUserName,
          staffGuid: staffGuid,
          tenantGuid: ruleForm.tenantGuid,
          doctorName: ruleForm.doctorName,
          mobileNo: ruleForm.mobileNo,
          sex: ruleForm.sex,
          medName: ruleForm.medName,//医院
          medGuid: ruleForm.medGuid,

          medDeptGuid: ruleForm.medDeptGuid,
          medDeptName: ruleForm.medDeptName,
          goodsInfoList: ruleForm.goodsInfoList,

          createUserTenantGuid: ruleForm.createUserTenantGuid,
          createUserTenantName: this.createUserTenantName,

          province: ruleForm.province,
          city: ruleForm.city,
          district: ruleForm.district,
          venue: ruleForm.venue,
          bizState: ruleForm.bizState,

          technicalTitles: ruleForm.technicalTitles,//职称
          monthDiagnoseNum: ruleForm.monthDiagnoseNum,//月门诊次数
          diagnoseNum: ruleForm.diagnoseNum,//每次门诊量
          attackRate: ruleForm.attackRate,//适应证发病率
          recipeStrength: ruleForm.recipeStrength,//处方强度
          potentialMeasure: ruleForm.potentialMeasure, //潜力量
          targetMeasure: ruleForm.targetMeasure,//目标量
          level: ruleForm.level,
          inputPlan: ruleForm.inputPlan,

          inputDate: ruleForm.inputDate,
          accountMonth: ruleForm.accountMonth.replace('-', '')
        };
        self.fullscreenLoading = true;
        self.api.postJson(`/${serverConfig.msPersonnelService}/doctor/pc-add`, promise).then((res) => {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('提交成功');
            if (type == 1) {
              if (this.$route.query.medGuid) {
                this.linkReset();
              } else {
                this.reset();
              }
            } else {
              this.back();
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
      }, 
      upDateForm() { 
        let self = this;   
        if (!this.ruleForm.tenantGuid) {
           this.$message.error(`所属公司不能为空`)
          return;
        }
        if (!this.ruleForm.doctorName) {
           this.$message.error(`医生姓名不能为空`)
          return;
        }
        if (!this.ruleForm.mobileNo) {
           this.$message.error(`手机号不能为空`)
          return;
        }
        // const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
        // if (this.ruleForm.mobileNo && !reg.test(this.ruleForm.mobileNo)) {
        //    this.$message.error("请填写正确手机号")
        //   return;
        // }
        if (!this.ruleForm.sex) {
           this.$message.error(`性别不能为空`)
          return;
        }
        if (!this.ruleForm.medGuid) {
           this.$message.error(`所在医院不能为空`)
          return;
        }
        if (!this.ruleForm.medDeptGuid) {
           this.$message.error(`所在科室不能为空`)
          return;
        }
        if (!this.ruleForm.createUserId) {
           this.$message.error(`所属人员不能为空`)
          return;
        }
        if (!this.ruleForm.province) {
           this.$message.error(`所属区域不能为空`)
          return;
        }
        if (!this.ruleForm.accountMonth) {
           this.$message.error(`核算月份不能为空`)
          return;
        }
        if (this.$NameCheck(this,this.ruleForm.doctorName,'doctorName')) { // todo 姓名长度校验
          return
        }
        let ruleForm = this.ruleForm;
        let createUserName = '';
        let staffGuid = ''; 
        if(self.staffList){
          self.staffList.forEach((i)=>{
            if(i.userGuid == ruleForm.createUserId){
              createUserName = i.staffName;
              staffGuid = i.guid;
            }
          })
        }
        let promise = {
          createUserName,
          staffGuid,
          createUserId:ruleForm.createUserId,
          createUserMobile: this.createUserMobile,
          guid:this.$route.query.guid,
          tenantGuid: ruleForm.tenantGuid,
          doctorName:ruleForm.doctorName,
          mobileNo:ruleForm.mobileNo,
          sex:ruleForm.sex,
          medName:ruleForm.medName,//医院
          medGuid:ruleForm.medGuid,

          medDeptGuid:ruleForm.medDeptGuid,
          medDeptName:ruleForm.medDeptName,
          goodsInfoList: ruleForm.goodsInfoList,

          createUserTenantGuid: ruleForm.createUserTenantGuid,
          createUserTenantName: this.createUserTenantName,

          province: ruleForm.province,
          city: ruleForm.city,
          district: ruleForm.district,
          venue:ruleForm.venue,
          bizState:ruleForm.bizState,

          technicalTitles:ruleForm.technicalTitles,//职称
          monthDiagnoseNum:  ruleForm.monthDiagnoseNum,//月门诊次数
          diagnoseNum: ruleForm.diagnoseNum,//每次门诊量
          attackRate: ruleForm.attackRate,//适应证发病率
          recipeStrength: ruleForm.recipeStrength,//处方强度
          potentialMeasure:ruleForm.potentialMeasure, //潜力量
          targetMeasure:ruleForm.targetMeasure,//目标量
          level: ruleForm.level,
          inputPlan: ruleForm.inputPlan,

          inputDate: ruleForm.inputDate,
          accountMonth:ruleForm.accountMonth.replace('-',''),
          serviceTenantGuid:localStorage.guid,
        };
        self.fullscreenLoading = true;
        self.api.put(`/${serverConfig.msPersonnelService}/doctor/pc-update`, promise).then((res) => {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('提交成功');
            this.back();
          } else {
            self.$message.error(res.data.msg);
          }
        });

      },
      back(){
        this.$router.go(-1);
      },
      nameBlur(val,formObj,fildeName) {
        
        formObj[fildeName] = this.$NameCheckBlur(this,val,fildeName)
      }
    },
    computed: {
      createUserTenantName() {
        const tenantName = this.serviceTenants?.find(item => item.guid == this.ruleForm.createUserTenantGuid)?.tenantName;
        return tenantName;
      },
      createUserMobile() {
        const mobile = this.staffList?.find(item => item.userGuid == this.ruleForm.createUserId)?.mobileNo;
        return mobile;
      },
    },
  };
</script> 
<style lang="less" scoped>
.content {
  padding: 0px;
  margin: 0px;
  // padding-bottom: 60px;
  .title-box {
    border-top: 1px solid #e5e5e5;
    background-color: #ffffff;
    padding: 8px 0px;
    position: relative;
    button {
      font-size: 12px;
      color: #212121;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      padding: 0px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      position: absolute;
      left: 16px;
      top: 6px;
    }
    span {
      text-align: center;
      font-size: 16px;
      font-weight: 400;
    }
  }
  .form-box {
    margin-top: 4px;
    text-align: left;
    .form-title {
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      margin-left: 16px;
    }
    .form-item-box {
      width: 90%;
      margin: 0 auto;
      padding-bottom: 15px;
    }
    .el-col-12 {
      margin-bottom: 12px;
    }
    .el-form-item {
      margin-bottom: 0px;
    }
    .el-input,
    .el-select {
      width: 314px;
    }
    .age-are-box {
      display: flex;
      align-items: center;
      .el-input {
        width: 142px;
      }
      span {
        margin: 0px 8px;
      }
    }
    .bottom-btn-box {
      padding: 18px 0px;
      text-align: center;
      border-top: 1px solid #e5e5e5;
    }
  }

  /deep/ .el-form-item__error {
    padding-top: 0px;
  }
  .el-button--primary {
    color: #ffffff;
  }

  .file-list-box {
    display: flex;
    // justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 32px;
    .upload-file-box {
      max-width: calc(100% - 132px - 16px);
    }
    .btn-box {
      position: absolute;
      width: 180px;
      margin-left: 16px;
      height: 32px;
      left: 430px;
    }
  }
  .operte-btns {
    background: #fff;
    margin-top: 2px;
    display: flex;
    justify-content: center;
    padding: 25px 0;
  }

  .operte-btns .btn {
    padding: 5px 18px;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    cursor: pointer;
    margin-right: 10px;
  }

  .operte-btns .btn.save {
    border: 1px solid rgba(79, 161, 164, 1);
    color: rgba(79, 161, 164, 1);
    cursor: pointer;
  }

  .operte-btns .btn.submit {
    border: 1px solid rgba(79, 161, 164, 1);
    background: rgba(79, 161, 164, 1);
    color: #fff;
    cursor: pointer;
  }
}
/deep/ .el-upload__tip {
  line-height: 1;
  margin-top: 8px;
}
.sub-title {
  line-height: 28px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.sub-operate-add {
  color: #4fa1a4;
  margin-left: 14px;
  cursor: pointer;
}
.sub-operate-add2 {
  position: absolute;
  right: 0px;
  top: -35px;
}
.sub-operate-add3 {
  position: absolute;
  right: 30px;
  top: 5px;
}
/deep/.el-select-dropdown .el-select-dropdown__item {
  color: #212121;
}
/deep/ .el-upload-list__item {
  // width
  max-width: 430px;
}
</style>
<style scoped>
.content-main-box {
  height: 100%;
  max-height: 300px;
}
.el-table .el-table__cell {
  padding: 0px;
}
.addPeople {
  width: 84px;
  height: 28px;
  margin-top: 5px;
  border: 1px solid #4fa1a4;
  text-align: center;
  line-height: 28px;
  color: #4fa1a4;
}
.mt20 .el-form-item__content {
  width: 830px;
}

.content {
  margin: 0px;
}
.iframe-sty {
  width: 100%;
  height: 500px;
  border: none;
  /* background:grey; */
}
.costApprove {
  text-align: left;
  background: #fff;
  margin: 16px;
  padding: 20px 30px;
  display: flow-root;
}

.cost-title {
  height: 72px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.cost-title .flow-name {
  color: #323233;
  font-size: 20px;
}
.cost-title .task-tips {
  margin-left: 20px;
}
.cost-title .flow-back {
  height: 32px;
  line-height: 32px;
  font-size: 16px;
  color: #323233;
  padding: 0 26px;
  border: 1px solid #c8c9cd;
  cursor: pointer;
}
.cost-title-list {
  display: flex;
  align-items: center;
  height: 32px;
  line-height: 32px;
  padding-left: 20px;
  background: #f6f7fa;
}
.cost-title-list-line {
  display: inline-block;
  width: 6px;
  height: 14px;
  background: #4fa1a4;
}
.cost-title-list-txt {
  font-size: 18px;
  color: #323233;
  padding-left: 6px;
}
.cost-approve-list {
  display: flex;
  margin: 18px 0;
  position: relative;
  margin-bottom: 10px;
  width: 860px;
}
.cost-approve-list .tips {
  position: absolute;
  color: red;
  font-size: 12px;
  bottom: -6px;
  left: 145px;
}

.cost-approve-list-title {
  width: 145px;
  text-align: right;
  flex-shrink: 0;
  line-height: 40px;
  padding-left: 25px;
  box-sizing: border-box;
}
.cost-approve-list-content {
  flex: 1;
}
.cost-submit-btn {
  display: flex;
  justify-content: center;
  /* padding: 50px 0; */
  padding-bottom: 20px;
}
.cost-submit-btn-sure {
  color: #fff;
  width: 112px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #4fa1a4;
  cursor: pointer;
  margin-left: 20px;
}
.cost-submit-btn-cancel {
  color: #fff;
  width: 112px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #c8c9cc;
  cursor: pointer;
}
.cost-approve-list-content a {
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
  line-height: 40px;
}
.cost-header {
  display: flex;
  background: #f0f0f0;
  font-size: 12px;
  border-right: 1px solid #dfdfdf;
}
.cost-header .header-child {
  flex: 1;
  padding: 10px;
  border-right: 1px solid #dfdfdf;
}
.cost-header .header-child:last-child {
  border-right: 0 none;
}
.cost-wrap {
  border: 1px solid #dfdfdf;
  border-right: 0 none;
}
.cost-list-content {
  display: flex;
  border-bottom: 1px solid #dfdfdf;
}
.cost-list-content:last-child {
  border-bottom: 0 none;
}
.cost-list-content .header-child {
  flex: 1;
  padding: 10px;
  display: flex;
  align-items: center;
  border-right: 1px solid #dfdfdf;
}
.cost-list-content .add {
  color: #4fa1a4;
  cursor: pointer;
}
.cost-list-content .del {
  color: #d0021b;
  cursor: pointer;
}
.header-select span {
  margin-left: 6px;
}
.cost-row {
  display: flex;
}
.cost-row .cost-approve-list {
  width: 500px;
}
.cost-row-colum {
  width: 860px;
}
.cost-sub-title {
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  padding-left: 60px;
  margin-top: 10px;
}
.cost-sub-title .line {
  width: 860px;
  height: 1px;
  background: #dadada;
  margin-left: 20px;
}
.margin100 {
  margin-left: 60px;
}
.map-a-sty {
  width: 90px;
  height: 28px;
  line-height: 28px;
  color: #4fa1a4;
  margin-top: 5px;
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid #4fa1a4;
  text-align: center;
  cursor: pointer;
  box-sizing: border-box;
}
/deep/ .el-dialog__body {
  padding: 10px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
/deep/ .el-dialog__footer {
  padding: 0px 20px 20px;
  text-align: right;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.header-sty {
  width: 100%;
  height: 65px;
  line-height: 65px;
}
.txt-sty {
  color: #323233;
  font-size: 20px;
  float: left;
  width: 90%;
  text-align: center;
}
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
::v-deep input[type='number'] {
  -moz-appearance: textfield;
}
</style>
<style>
.reimbursement-check /deep/.el-checkbox__label {
  display: none !important;
}
</style>